import { Icon, IconButton } from '@mui/material';
import { setNotifications } from '../../redux/features/notificationSlice';

export const generateNotifications = ({
  title = '',
  descriptions = '',
  enqueueSnackbar = null,
  closeSnackbar = null,
  reduxDispatch = null,
} = {}) => {
  if (enqueueSnackbar && closeSnackbar && reduxDispatch) {
    const action = snackbarId => (
      <>
        <IconButton
          onClick={() => {
            closeSnackbar(snackbarId);
          }}
        >
          <Icon>close</Icon>
        </IconButton>
      </>
    );

    enqueueSnackbar(descriptions, {
      action,
      sx: {
        '& .SnackbarContent-root': {
          color: '#275672',
          backgroundColor: 'white',
        },
      },
    });

    reduxDispatch(
      setNotifications({
        title,
        descriptions,
      })
    );
  } else {
    console.error(
      `generateNotifications->Error in generating notifications, either enqueueSnackbar, closeSnackbar and reduxDispatch parameters are not passed`
    );
  }
};
